<template>
  <section class="content-section primary">
    <div class="section-title">
        <!-- <div class="section-title-line"></div> -->
        <h1>MATERIALSUCHE</h1>
        <!-- <div class="section-title-line"></div> -->
    </div>
    <div class="container" >
      
      </div>
    </section>
</template>

<script>
import axios from "axios";
export default {
    name: "Materialsuche",
    metaInfo: {
        title: "Materialsuche",
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "Finden Sie den richtigen Naturstein für ihr Vorhaben!"
            },
            {
                vmid: "keywords",
                name: "keywords",
                content:
                    "Naturstein finden, Quarzstein finden, Keramik finden, Naturstein Materialsuche, Naturstein Mönchengladbach, Marmor Mönchengladbach"
            }
        ],
        links: [
            {
                rel: "canonical",
                href: "https://www.marmor-kunze.de/material/materialsuche"
            }
        ]
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Materialsuche.vue